<template>
  <div class="container-xl p-0 py-sm-2 px-sm-3">
    <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb mb-0">
        <template v-for="(label, link, index) in links" v-bind:key="index">
          <li v-if="link == 'current'" class="breadcrumb-item active">{{ label }}</li>
          <li v-else class="breadcrumb-item">
            <router-link :to="link">{{ label }}</router-link>
          </li>
        </template>
      </ol>
    </nav>
  </div>
</template>

<script>
export default {
  props: ['links']
}
</script>
